module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-left.df133270.svg";